import {getHref, Routes} from '../../../../../../routes'
import {BuildStatusType} from '../../../../../../types'

import type {Link} from './Breadcrumbs.types'

const HOME_LINK: Link = {
  to: getHref(Routes.ALL_PIPELINES),
  name: 'Home',
}

export const getCreatePipelineBreadcrunbs = (): Link[] => [
  HOME_LINK,
  {
    name: 'Create pipeline',
  },
]

export const getPipelineBreadcrunbs = (id: string, name: string): Link[] => [
  HOME_LINK,
  {
    name,
  },
]

export const getEditPipelineBreadcrunbs = (id: string, name: string): Link[] => [
  HOME_LINK,
  {
    to: getHref(Routes.PIPELINE, {id}),
    name,
  },
  {
    name: 'Editing',
    rightIcon: 'settings',
  },
]

export const getPipelineRunBreadcrunbs = (
  id: string,
  name: string,
  runNumber: string | undefined,
  runStatusType: BuildStatusType,
): Link[] => [
  HOME_LINK,
  {
    to: getHref(Routes.PIPELINE, {id}),
    name,
  },
  {
    name: runStatusType === BuildStatusType.QUEUED ? 'In queue' : `Run ${runNumber}`,
  },
]
